export const SOCIAL_MEDIA = {
  facebook: "facebook",
  twitter: "twitter",
  linkedin: "linkedin",
};
